import VueI18n from 'vue-i18n'

const CURRENT_LOCALE = 'cs'

const dateTimeFormats = {
  cs: {
    long: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    },
    dayMonth: {
      month: '2-digit',
      day: '2-digit',
    },
  },
}

const pluralizationRules = {
  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index to select plural word by
   */
  cs: function (choice, choicesLength) {
    if (choice === 0) {
      return 0
    }
    if (choice === 1) {
      return 1
    }
    if (choice < 5) {
      return choicesLength === 3 ? 2 : 0
    }
    return 0
  },
}

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.ya?ml$/i)
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return { messages, moduleId: locales.id }
}

const createI18n = () => {
  const { messages, moduleId } = loadLocaleMessages()

  const i18n = new VueI18n({
    locale: CURRENT_LOCALE,
    fallbackLocale: CURRENT_LOCALE,
    dateTimeFormats,
    pluralizationRules,
    messages,
  })

  if (module.hot) {
    module.hot.accept(moduleId, () => {
      const { messages } = loadLocaleMessages()
      for (const [locale, localeMessages] of Object.entries(messages)) {
        i18n.setLocaleMessage(locale, localeMessages)
      }
    })
  }

  return i18n
}

export default {
  i18n: null,
  getI18n() {
    return this.i18n
  },
  createFor(vueInstance) {
    vueInstance.use(VueI18n)
    this.i18n = createI18n()
    return this.getI18n()
  },
}
